export { default as ListView } from 'catalogs/components/CatalogsListView';
export { default as FormView } from 'catalogs/components/CatalogFormView';
export { default as Row } from 'catalogs/components/list/CatalogsListRow';



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/index.js